export const fullscreenModes = [
  "braze_modal",
  "classic_editor_expanded",
  "email_composer",
  "email_dnd_composer",
  "canvas_modal_edit",
  "canvas_fullscreen",
  "banner_composer",
  "iam_composer",
  "line_composer",
  "line_editor",
  "landing_pages_composer",
  "email_preference_center_composer",
  "content_block_composer",
  "content_block_dnd_composer",
  "subscription_page_composer",
  "email_footer_composer",
  "canvas_version_history",
  // Opened over a near-full-screen media-library picker modal; gets the same
  // full-height treatment so Operator uses the available vertical space.
  "media_library_modal",
] as const;

export type FullscreenMode = (typeof fullscreenModes)[number];
